/**
 * META1-04 (PR #352): diálogo de confirmación para acciones críticas.
 *
 * Cuando el asistente intenta ejecutar una acción crítica (reasignar lead,
 * cambiar estado propiedad), el backend retorna requiresConfirmation=true.
 * Este diálogo muestra el summary y captura accept/reject del usuario.
 */
import React from 'react';
import { PendingConfirmation } from '../api/agent-assistant-api';

export interface ConfirmActionDialogProps {
  open: boolean;
  confirmation: PendingConfirmation | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmActionDialog: React.FC<ConfirmActionDialogProps> = ({
  open,
  confirmation,
  onConfirm,
  onCancel,
}) => {
  if (!open || !confirmation) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
    >
      <div className="w-full max-w-md rounded-lg bg-white p-5 shadow-xl">
        <div className="mb-3 flex items-center gap-2">
          <span className="text-2xl">⚠️</span>
          <h2 className="text-lg font-bold text-gray-900">Confirmar acción</h2>
        </div>
        <p className="mb-2 text-sm text-gray-700">
          Esta acción es crítica y revertirla requiere intervención manual.
          Revisa los detalles antes de continuar.
        </p>
        <div className="mb-4 rounded bg-yellow-50 p-3">
          <div className="text-xs font-semibold uppercase text-yellow-700">
            {confirmation.toolName}
          </div>
          <div className="mt-1 text-sm text-yellow-900">{confirmation.summary}</div>
          <details className="mt-2">
            <summary className="cursor-pointer text-xs text-yellow-600">
              Ver parámetros
            </summary>
            <pre className="mt-1 text-xs text-yellow-700">
              {JSON.stringify(confirmation.input, null, 2)}
            </pre>
          </details>
        </div>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="rounded px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="rounded bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700"
          >
            Confirmar y ejecutar
          </button>
        </div>
      </div>
    </div>
  );
};
